import {
  RequirementStepsResponse,
  StepDetailsResponse
} from '../types/RequirementSteps.types';
import API from './ApiBase';

export const fetchRequirementSteps = async (
  aiSystemId: string
): Promise<RequirementStepsResponse> => {
  try {
    const response = await API.get<RequirementStepsResponse>(
      `/requirements/${aiSystemId}/steps`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching requirement steps:', error);
    throw error;
  }
};

export const fetchStepActions = async (
  stepId: string
): Promise<StepDetailsResponse> => {
  try {
    const response = await API.get<StepDetailsResponse>(
      `/requirements/${stepId}/actions`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching step actions:', error);
    throw error;
  }
};

export const finishCompliance = async (aiSystemId: string) => {
  try {
    const response = await API.patch(
      `/requirements/${aiSystemId}/finish-compliance`
    );
    return response.data;
  } catch (error) {
    console.error('Error finishing compliance:', error);
  }
};
